import { Alert, Button, Snackbar } from '@mui/material';
import React from 'react';

export interface NoCalendarsSelectedNoticeProps {
  open: boolean;
  onClose: () => void;
  onSettingsClick: () => void;
}

const NoCalendarsSelectedNotice: React.FC<NoCalendarsSelectedNoticeProps> = ({
  open,
  onClose,
  onSettingsClick,
}) => {
  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      onClose={onClose}
    >
      <Alert
        severity="info"
        onClose={onClose}
        action={
          <Button color="inherit" size="small" onClick={onSettingsClick}>
            Настроить
          </Button>
        }
      >
        Выберите календари для отображения событий
      </Alert>
    </Snackbar>
  );
};

export { NoCalendarsSelectedNotice };
